@if (isLoading) {
  <div class="flex justify-center">
    <p-progressSpinner />
  </div>
}

<mnc-pac-interrupted-stay-dialog
  lazyComponent
  [hidden]="isLoading"
  [tenantId]="dialogConfig?.data?.tenantId"
  [productId]="dialogConfig?.data?.productId"
  [memberId]="dialogConfig?.data?.memberId"
  [interruptedStay]="dialogConfig?.data?.interruptedStay"
  [isExternal]="dialogConfig?.data?.isExternal"
  [isProviderDashboard]="dialogConfig?.data?.isProviderDashboard"
  (closeDialogEvent)="closeDialog($event.detail)"
  (initCompleted)="isLoading = false"
  (navigationEvent)="handleNavigation($event.detail)"
></mnc-pac-interrupted-stay-dialog>
